export default {"src":"/_next/static/media/dift-full-white.ff7fcb00.svg","height":56,"width":137,"blurWidth":0,"blurHeight":0};